import { CountingCirclesRecord } from 'api/api.types';

export const MAP_COLOR_STEPS = [100, 70, 65, 60, 55, 50, 45, 40, 35, 30];

const getMapColorPoll = (record: CountingCirclesRecord) => {
  const yesPercentage = record.results?.poll_data.yes_votes_percentage;

  const hasData = !Number.isNaN(yesPercentage);

  const colorClass = [...MAP_COLOR_STEPS].reverse().find((step) => yesPercentage <= step);
  const fillColor = `var(--map-color-${colorClass})`;

  return { hasData, fillColor };
};

export default getMapColorPoll;
